import { useCallback, useEffect } from 'react'
import { Artist } from 'shared/__gql-types'
import { mergeWith, isArray } from 'lodash'

import { DEFAULT_ENTITIES_LIMIT } from 'shared/consts'
import { usePreviousNonNullish } from 'shared/hooks'
import { useGetArtistsLazyQuery } from '../graphql/queries/getArtists.types'

export const useArtists = () => {
  const [getArtists, {
    data: artistsResponse,
    error: artistsError,
    loading: artistsLoading,
    fetchMore: fetchMoreArtists
  }] = useGetArtistsLazyQuery({
    notifyOnNetworkStatusChange: true,
  })

  const prevArtists = usePreviousNonNullish(artistsResponse?.getArtists?.artists)
  const artists: Artist[] = artistsResponse?.getArtists?.artists ?? prevArtists ?? []
  const total = parseInt(artistsResponse?.getArtists?.total ?? '0')

  const increaseUsersOffset = () => {
    if (!artistsLoading) {
      fetchMoreArtists({
        variables: {
          offset: artists.length
        },
        updateQuery: (prev, { fetchMoreResult, variables: { offset } }) => {
          if (!fetchMoreResult) return prev
          return mergeWith(fetchMoreResult, prev,(objValue, srcValue) => {
            if (isArray(objValue)) {
              return [ ...srcValue, ...objValue]
            }
          })
        }
      })
    }
  }

  const onSearchArtist = useCallback((artistName: string) => {
    getArtists({
      variables: { offset: 0, limit: DEFAULT_ENTITIES_LIMIT, name: artistName }
    })
  }, [getArtists])

  useEffect(() => {
    getArtists({
      variables: { offset: 0, limit: DEFAULT_ENTITIES_LIMIT, name: '' }
    })
  }, [getArtists])

  return {
    artists,
    total,
    increaseUsersOffset,
    fetchMoreArtists,
    artistsLoading,
    artistsError,
    onSearchArtist
  }
}
